export default __webpack_public_path__ + "static/media/cross-icon-white.86667343.svg";